
import { Component, Vue } from 'vue-property-decorator'

interface INavItem {
    path: string
    text: string
}

@Component({ name: 'TechSidebar' })
export default class TechSidebar extends Vue {
    /** 导航项 - 与 router/modules/monitor.ts 同步 */
    private navItems: INavItem[] = [
        { path: '/monitor/dashboard', text: '仪表盘' },
        { path: '/monitor/api',       text: '接口分析' },
        { path: '/monitor/page',      text: '页面分析' },
        { path: '/monitor/risk',      text: '风控监测' },
        { path: '/monitor/settings',  text: '监测设置' }
    ]

    private isActive(path: string): boolean {
        return this.$route.path === path
    }
}
